import type { RouteRecordRaw } from 'vue-router'

const shopRoutes: RouteRecordRaw[] = [
  {
    path: '/pesanan',
    component: () => import('@/views/app/the-layout.vue'),
    children: [
      {
        path: '',
        name: 'shop order list',
        component: () => import('@/views/app/shop-order/list/page-list.vue'),
        meta: { title: 'List Pesanan' },
      },
      {
        path: 'buat',
        name: 'shop order create',
        component: () => import('@/views/app/shop-order/create/page-create.vue'),
        meta: { title: 'Buat Pesanan' },
      },
      {
        path: ':id',
        name: 'shop order detail',
        component: () => import('@/views/app/shop-order/detail/page-detail.vue'),
        meta: { title: 'Informasi Pesanan' },
        props: true,
      },
    ],
  },
  {
    path: '/pesanan/:id/print',
    name: 'shop order print',
    component: () => import('@/views/app/shop-order/print/page-print.vue'),
    meta: { title: 'Cetak Pesanan' },
    props: true,
  },
]

export default shopRoutes
